import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  // Default hidden — coordinator shows splash only when a route is not cached.
  private showSplashScreenSubject = new BehaviorSubject<boolean>(false);
  showSplashScreen$ = this.showSplashScreenSubject.asObservable();

  private hideGeneration = 0;
  private bootstrapSplashRemoved = false;

  show(): void {
    this.hideGeneration++;
    this.showSplashScreenSubject.next(true);
  }

  hide(): void {
    this.hideImmediate();
  }

  /** Hide without animation frame delay — used when template is already cached. */
  hideImmediate(): void {
    this.hideGeneration++;
    this.showSplashScreenSubject.next(false);
    this.removeBootstrapSplash();
  }

  hideAfterPaint(): void {
    const generation = ++this.hideGeneration;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (generation === this.hideGeneration) {
          this.showSplashScreenSubject.next(false);
          this.removeBootstrapSplash();
        }
      });
    });
  }

  private removeBootstrapSplash(): void {
    if (this.bootstrapSplashRemoved) {
      return;
    }

    document.getElementById('bootstrap-splash')?.remove();
    this.bootstrapSplashRemoved = true;
  }
}
